/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import useWorker from "~hooks/useWorker";
import { useGetParametros } from "~hooks/useBackOffice";

const useParametros = () => {

  const parameterSlugs = {
    credito: {
      quantidadeIncremento: 'credit-limit-increment-amount',
      valorMaximoSolicitacao: 'credit-limit-max-value',
      valorMinimoUpload: 'credit-limit-min-amount-upload',
      valorMinimoFlexUpload: 'credit-limit-min-amount-upload-flex',
      tempoSolicitarDocumentacao: 'requisitar-documentacao-limite-credito',
      tamanhoMaximoUploadMB: 'tamanho-maximo-upload-arquivos'
    },
    clientesTrilha: {
      clienteTac: 'cliente-tac',
      clienteInd: 'cliente-ind',
      clienteInfra: 'cliente-infra',
      clienteImo: 'cliente-imo'
    },
    mapaMina: {
      quantidadeDiasSemPesquisa: 'mapa-mina-dias-sem-pesquisas',
      quantidadeDiasMostrarData: 'mapa-mina-dias-mostrar-data-atualizacao'
    },
    lojaVirtual: {
      url: 'link-loja-virtual'
    },
    imo: {
      linkCadastroGrupo: 'imo-link-cadastro-grupo'
    },
    funil: {
      linkRelatorioConcreto: 'link-relatorio-concreto-funil'
    },
  }

  const parametrosRequest = useGetParametros(true, 0,0);

  const { save } = useWorker({
    table: "parametros",
  });

  useEffect(() => {
    if (parametrosRequest?.data) {
      save(parametrosRequest.data);
    }
  }, [parametrosRequest.data]);

  function getSlug(name, defaultValue = false) {
    return toObjectSlug[name] ? (toObjectSlug[name].valorCorrigido ?? defaultValue) : defaultValue;
  }

  const liveParametros = useLiveQuery(() => db.parametros.toArray(), []);
  const parametros = liveParametros ?? (parametrosRequest?.data ?? []);


  async function getBySlug(name) {
    if (toObjectSlug && toObjectSlug[name]) return toObjectSlug[name];
    return await db.parametros.filter((parametro) => parametro.slug === name).first();
  }

  const toObjectSlug = useMemo(() => {
    if (parametros?.length > 0) {
      return parametros.reduce((acc, cur) => {
        acc[cur.slug] = cur;
        return acc;
      }, {})
    }

    return {};
  }, [parametros]);

  function getBotoesCliente(trilha, botao) {
    trilha = trilha?.toLowerCase();
    const cliente = (parametros || []).find(parametro => parametro.slug === 'cliente-' + trilha);
    const botoes = cliente?.valor.split(',').map((item) => item.trim());
    if (!botoes) return false;
    return botoes.includes(botao);
  }

  return {
    parametros,
    getSlug,
    getBySlug,
    parameterSlugs,
    toObjectSlug,
    getBotoesCliente
  };
}

export default useParametros;